import React from 'react';
import JustRow from "../../styleHelper/JustRow"
import List from "../../styleHelper/List"
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import mockup from "../../images/home/mockup.png"
import all from "../../images/designed/All.svg"
import classOnline from "../../images/designed/classOnline.svg"
import videoConference from "../../images/designed/webConference.svg"
import wabinar from "../../images/designed/Dorehami.svg"
import easyToUse from "../../images/designed/easyToUse.svg"
import vidoeAndSound from "../../images/designed/vidoeAndSound.svg"
import MediaPlayer from "../../images/designed/MediaPlayer.svg"
import Sharedesc from "../../images/designed/Sharedesc.svg"
import Fade from 'react-reveal/Fade';
import Header from "../../sections/Header/Header"
import Footer from "../../sections/Footer"


export default function Home(props){
    return(
        <div id="landing">
            <Header/>
            <div className="home">
                <JustRow className={"imageBg leaf-color-light firstRow noMargin"} rowClass="align-items-md-center">
                    
                    <Col sm={6}>
                        <Fade right distance="50px">
                            <h1>آسان، هر لحظه و هر جا در ارتباط باشید!</h1>
                            <div className="description">
                                <p>دیداری، پلتفرم بومی خدمات وبینار ،کلاس آنلاین و وب کنفرانس</p>
                                <p>نسخه رایگان ما را برای دیداری زنده امتحان کنید!</p>
                            </div>
                            <div className="btns">
                                <a className="btn btn-primary" href="/">نسخه رایگان</a>
                            </div>
                        </Fade>
                    </Col>
                    <Col sm={6}>
                        <Fade left distance="50px">
                            <div className="imgBox"><img src={mockup} alt="پلتفرم دیداری"/></div>
                        </Fade>
                    </Col>
                    
                </JustRow>
                <JustRow className="threeCard">
                    <Col sm={4}>
                        <Fade bottom distance="50px">
                            <Card className="text-center">
                                <Card.Img variant="top" src={videoConference} />
                                <Card.Body>
                                    <Card.Title>وب کنفرانس</Card.Title>
                                    <Card.Text className="description">
                                        برگزاری وب کست و وبینار بصورت زنده و آنلاین
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Fade>
                    </Col>   
                    <Col sm={4}>
                        <Fade top distance="50px">
                            <Card className="text-center">
                            <Card.Img variant="top" src={classOnline} />
                            <Card.Body>
                                <Card.Title>کلاس آنلاین</Card.Title>
                                <Card.Text className="description">
                                    برگزاری آسان کلاسها و جلسات آموزشی بصورت زنده
                                </Card.Text>
                            </Card.Body>
                        </Card>
                        </Fade>
                    </Col>   
                    <Col sm={4}>
                        <Fade bottom distance="50px">
                            <Card className="text-center">
                            <Card.Img variant="top" src={wabinar} />
                            <Card.Body>
                                <Card.Title>دورهمی آنلاین</Card.Title>
                                <Card.Text className="description">
                                    ارتباط آسان و زنده تصویری با همکاران و خانواده
                                </Card.Text>
                            </Card.Body>
                        </Card>
                        </Fade>
                    </Col>     
                </JustRow>
                <JustRow className={"imageBg leaf-color"} 
                    title="درباره امکاناتی که در دیداری برای شما طراحی شده است بیشتر بدانید!">
                    <Col xs={12} md={6} >
                        <Fade right distance="50px">
                            <Card className="noStyle rightLayout">
                                <Card.Img variant="top" src={easyToUse} />
                                <Card.Body>
                                    <Card.Title>استفاده آسان</Card.Title>
                                    <Card.Text>
                                        دون نیاز به نصب هیچ نرم افزاری در مرورگرهای موبایل یا کامپیوتر خود بصورت کاملا فارسی در زمانی کوتاه از لذت دیداری زنده بهرمند شوید.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Fade>
                    </Col>
                    <Col xs={12} md={6}>
                        <Fade left distance="50px">
                            <Card className="noStyle rightLayout">
                                <Card.Img variant="top" src={vidoeAndSound} />
                                <Card.Body>
                                    <Card.Title>ارتباط دیداری و شنیداری</Card.Title>
                                    <Card.Text>
                                        به سادگی با فراگیران، دوستان و خانواده خود ارتباط امن دوطرفه زنده و با کیفیت برقرار کنید.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Fade>
                    </Col>
                    <Col xs={12} md={6}>
                        <Fade right distance="50px">
                            <Card className="noStyle rightLayout">
                                <Card.Img variant="top" src={MediaPlayer} />
                                <Card.Body>
                                    <Card.Title>پخش فایل های چند رسانه ای</Card.Title>
                                    <Card.Text>
                                        امکان اشتراک و پخش فایل های صوتی، تصویری و متنی برای کاربران خود در اتاق ها
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Fade>
                    </Col>
                    <Col xs={12} md={6}>
                        <Fade left distance="50px">
                            <Card className="noStyle rightLayout">
                                <Card.Img variant="top" src={Sharedesc} />
                                <Card.Body>
                                    <Card.Title>اشتراک دسکتاپ و وایتبرد</Card.Title>
                                    <Card.Text>
                                        به آسانی تخته مجازی با امکانات متنی و تصویری متنوع یا محیط دسکتاپ خود را برای کاربران اتاق به اشتراک بگذارید.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Fade>
                    </Col>
                </JustRow>
                <JustRow className="plan" title="آنچه در دیداری زنده و آنلاین برای شما آماده ساخته ایم!" rowClass="justify-content-center align-items-stretch">
                    <Col xs={12} sm={6} md={5}>
                        <Fade bottom distance="50px">
                            <Card>
                            <Card.Body>
                                <Card.Title>کلاس آنلاین</Card.Title>
                                <List className="withDivider description" listItems={[
                                    "پلن رایگان یک ماهه",
                                    "ایجاد تعداد کلاس نامحدود",
                                    "استفاده حداکثر 200 کاربر همزمان",
                                    "برگزاری همزمان کلاس تا سقف ظرفیت نفرات",
                                    "اشتراک حداقل 3 و حداکثر 10 ویدئو همزمان برای هر کلاس",
                                    "چت گروهی و اختصاصی",
                                    "اشتراک دسکتاپ، اسلاید و انواع فایل",
                                    "فرم حضور و غیاب و نظر سنجی"
                                ]}/>
                                <div className="btns alignCenter">
                                    <a href="/" className="btn btn-primary">بیشتر بدانید</a>
                                </div>
                            </Card.Body>
                        </Card>
                        </Fade>
                    </Col>
                    <Col xs={12} sm={6} md={5}>
                        <Fade bottom distance="50px" delay={250}>
                            <Card>
                                <Card.Body>
                                    <Card.Title>وب کنفرانس</Card.Title>
                                    <List className="withDivider description" listItems={[
                                        "پلن رایگان یک ماهه",
                                        "امکان ایجاد تعداد گروه های نامحدود",
                                        "اشتراک حداکثر 10 ویدئو همزمان در کل گروه ها",
                                        "امکان ارسال دعوت نامه بی نام برای سمینار عمومی",
                                        "دارای تمامی امکانات موجود در پلن کلاس آنلاین",
                                        "استفاده حداکثر 100 کاربر همزمان در کل گروه ها",
                                    ]}/>
                                    <div className="btns alignCenter">
                                        <a href="/" className="btn btn-primary">بیشتر بدانید</a>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Fade>
                    </Col>
                </JustRow>
                <JustRow 
                    fluid={true}
                    className={"colorBg gray-light noMargin"}
                    title="پلتفرم یکپارچه کلاس آنلاین، پخش زنده ویدئو، وبینار و وب کنفرانس" 
                    description="همراه با ما به سادگی دیداری تازه کنید!">
                        <Col className="alignCenter">
                            <Fade bottom distance="50px">
                                <div className="btns rowBtns">
                                    <a href="/" className="btn btn-primary">رایگان شروع کنید</a>
                                    <a href="/" className="btn btn-secondary">ثبت نام کنید</a>
                                </div>
                            </Fade>
                            <Fade bottom distance="10px">
                                <img src={all} alt="s"/>
                            </Fade>
                        </Col>
                </JustRow>
            </div>
            <Footer/>
        </div>
    )
}